import EntryCarousel from "@/components/EntryCarousel";
import clsx from "clsx";

const YouMightLikeEntries = ({ entries, heading = "You might like?" }) => {
  if (!entries || entries.length === 0) {
    return null;
  }

  return (
    <div className={clsx("space-y-4 lg:space-y-6 2xl:space-y-8")}>
      {heading && (
        <div className="px-6 lg:px-12">
          <h2 className="heading-sm--spatial">{heading}</h2>
        </div>
      )}
      <EntryCarousel
        entries={entries}
        showSection
        showChef
        showSummary={false}
      />
    </div>
  );
};

export default YouMightLikeEntries;
